<template>
  <div class="bg-white p-3">
    <div class="d-flex flex-wrap">
      <div class="m-2 flex-grow-1">
        <label>{{ trans('event.assessment_configs.assessment') }}</label>
        <input
          :value="event.name"
          class="form-control"
          disabled
        >
      </div>
      <div class="m-2 flex-grow-1">
        <label>{{ trans('event.assessment_configs.date') }} {{ trans_lc('event.assessment_configs.timeslot') }}</label>
        <input
          :value="event.displayDate"
          class="form-control"
          disabled
        >
      </div>
      <div class="m-2 flex-grow-1">
        <label>{{ trans('event.assessment_configs.registered_students') }}</label>
        <input
          :value="event.students.length"
          class="form-control"
          disabled
        >
      </div>
    </div>
    <div class="m-2">
      <label>{{ trans('event.assessment_configs.assessment') }}</label>
      <select
        v-model="selectedAssessmentConfigValue"
        class="form-control p-2 my-1"
        aria-label="Default select example"
        disabled
      >
        <template v-for="(key, optionValue) in selectedAssessmentConfigOptions">
          <option
            :key="key"
            :value="optionValue"
          >
            {{ trans(`event.assessment_configs.types.${optionValue}`) }}
          </option>
        </template>
      </select>
    </div>
    <AssessmentConfigSingleStudentView
      v-if="selectedAssessmentConfigValue === selectedAssessmentConfigOptions.single_student"
      :event="event"
      @change-step="nextStep()"
    />
  </div>
</template>

<script>
import { ASSESSMENT_CONFIG_TYPES } from '@/constants'
import { mapState } from 'vuex'
import AssessmentConfigSingleStudentView
  from '@/employees/components/AssessmentConfig/view/AssessmentConfigSingleStudentView'

export default {
  name: 'AssessmentConfigCreateStepOneView',
  components: {
    AssessmentConfigSingleStudentView,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      selectedAssessmentConfigValue: ASSESSMENT_CONFIG_TYPES.single_student,
      selectedAssessmentConfigOptions: ASSESSMENT_CONFIG_TYPES,
    }
  },
  computed: {
    ...mapState({
      assessmentConfig (state) {
        return state.events.assessment_configs[this.event.assessmentConfig]
      },
    }),
  },
  methods: {
    nextStep () {
      this.$store.dispatch('generateAssessmentConfigEvents',
        {
          assessmentConfigId: this.event.assessmentConfig,
          data: {
            config_type: this.assessmentConfig.config_type,
            config_data: this.assessmentConfig.config_data,
          },
        }).then(() => { this.$emit('change-step', 1, this.event.id) })
    },
  },
}
</script>
